export const GRADUATING_YEAR_START_YEAR = 1959;
